import { __decorate } from "tslib";
import { Component, Vue, Ref, Watch } from 'vue-property-decorator';
import { AppModule } from '@blade/common/store/app';
import { getTreeData, addTreeNode, editTreeNode, delTreeNode, byExportGroup } from '@blade-sxp/its-management/api/index'; // 接口
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
import InputSearch from '@blade-sxp/its-management/components/input-search.vue';
import { getAllChilderId } from '@blade/common/utils/childer-tree-list';
let default_1 = class default_1 extends Vue {
    tree;
    form = { groupName: '' };
    title = '';
    groupName = '';
    dialogVisible = false;
    value = ''; // keyword查询
    dialogStatus = ''; // 弹窗的状态
    submitLoading = false; // 确认按钮的loading状态
    fullSkDialogVisible = false;
    nodeExport = {};
    outerPage = 1;
    outerPageSize = 10;
    outerOpen = false;
    mode = 'ORGAEDIT';
    currIndex = 0;
    parentId = 0;
    treeData = [];
    command = 0;
    curParentId = '';
    groupId = 0;
    async mounted() {
        await this.getTreeData();
        // fix SXISSUE-4773
        this.$nextTick(() => {
            if (this.treeData) {
                let rootGroup = this.treeData.find((t) => t.name === 'root');
                if (rootGroup) {
                    this.currIndex = rootGroup.id; // 设置选中
                    this.handleNodeClick(rootGroup); // 选中回到上层
                    this.$refs.tree.setCurrentKey(rootGroup.id); // 高亮
                }
            }
        });
    }
    get language() {
        return AppModule.language;
    }
    getNameLength(name) {
        if (name.length > 30) {
            return `${name.slice(1, 27)}...`;
        }
        else {
            return name;
        }
    }
    // 获取树 数据
    async getTreeData() {
        let data = {
            groupName: this.value,
        };
        try {
            let resp = await getTreeData(data);
            this.treeData = resp?.tree ?? [];
            this.$nextTick(() => {
                if (this.currIndex) {
                    this.$refs.tree.setCheckedKeys([this.currIndex]);
                    this.$refs.tree.setCurrentKey(this.currIndex); // 高亮
                }
            });
        }
        catch (error) {
            console.log('getTreeData err', error);
        }
    }
    exprotByFroupId(item) {
        this.fullSkDialogVisible = true;
        this.nodeExport = item;
        // const id = Number(item.data.id);
        // byExportGroup({ groupIds: [id] }).then((res: any) => {
        //   window.location.href = res;
        // });
    }
    handleExport() {
        const id = Number(this.nodeExport.data.id);
        const groupIds = [...(getAllChilderId(this.nodeExport.data.id, this.treeData) || []), id];
        byExportGroup({ groupIds: groupIds }).then((res) => {
            window.location.href = res;
        });
    }
    handleNodeClick(node) {
        if (node.name === 'Ungrouped Device' || node.name === 'Favorites') {
            this.$emit('changeBatchBtnIsShow', false);
        }
        else {
            this.$emit('changeBatchBtnIsShow', true);
        }
        this.currIndex = Number(node.id); // 设置选中
        this.$emit('getroup-id', node.id);
    }
    /**
     *@Description: 创建/修改 设备组
     */
    handleSubmit() {
        this.submitLoading = true;
        try {
            if (this.command === 1 || this.command === 2) {
                let data = { name: this.groupName, parentId: this.parentId };
                addTreeNode(data)
                    .then(() => {
                    this.dialogVisible = false;
                    this.$message({
                        message: `${this.$t('createSuccess')}`,
                        type: 'success',
                    });
                    this.getTreeData();
                })
                    .finally(() => {
                    this.submitLoading = false;
                });
            }
            else if (this.command === 3) {
                // 重命名
                editTreeNode(this.currIndex, { name: this.groupName, groupId: this.currIndex })
                    .then(() => {
                    this.getTreeData();
                    this.dialogVisible = false;
                    this.$message({
                        message: `${this.$t('editSuccess')}`,
                        type: 'success',
                    });
                })
                    .finally(() => {
                    this.submitLoading = false;
                });
            }
        }
        catch (error) {
            console.log('handleSubmit err', error);
            this.submitLoading = false;
        }
    }
    // 创建组
    creatFirst(node) {
        if (node.level >= 4) {
            this.$message({
                message: this.$t('cannotBeAdd'),
                type: 'warning',
            });
            return;
        }
        this.title = `${this.$t('createTitle')}`;
        this.command = 1;
        this.parentId = node.data.id;
        this.dialogVisible = true;
        this.dialogStatus = 'add';
        this.clearGroupInfo();
    }
    // 编辑组
    onEdit(node) {
        this.command = 3;
        this.title = `${this.$t('editTitle')}`;
        this.dialogVisible = true;
        this.dialogStatus = 'edit';
        this.curParentId = node.data.parentId;
        this.currIndex = node.data.id;
        this.getGroupInfo(node);
    }
    // 获取树节点数据
    getGroupInfo(node) {
        this.groupName = node.data.name;
        const id = node.data.id;
        this.groupId = id;
    }
    clearGroupInfo() {
        this.groupName = '';
    }
    onRemove() {
        const id = this.groupId;
        delTreeNode(id).then(() => {
            this.$message({
                message: `${this.$t('removeSuccess')}`,
                type: 'success',
            });
            this.dialogVisible = false;
            this.getTreeData();
        });
    }
    // 节点开始拖拽时触发的事件
    handleDragStart(node, $event) {
        this.$refs.tree.setCurrentKey(node.data.id);
        $event.dataTransfer.setData('drag', JSON.stringify(node.data));
    }
    // 判断节点能否被拖拽
    handleDrag(node) {
        if (node.childNodes.length === 0) {
            return true;
        }
        return false;
    }
    handleSearch() {
        this.getTreeData();
    }
    // 树本身过滤
    filterNode(value, data, node) {
        return this.filterNodeAndParent(value, data, node);
    }
    // 递归检测父元素或自己是否符合条件
    filterNodeAndParent(value, data, node) {
        if (node.level === 1) {
            return node.data.label.indexOf(value) !== -1;
        }
        else if (data.level !== 1) {
            // 判断自己是否符合条件
            if (node.data.label.indexOf(value) !== -1) {
                return true;
            }
            else {
                // 否则查找父级
                return this.filterNodeAndParent(value, node.data, node.parent);
            }
        }
    }
    watchValue(newVal) {
        this.throttle(this.getTreeData(), 500);
    }
    // 节流函数
    flag = false;
    throttle(fn, delay) {
        this.flag = true;
        const that = this;
        return function (e) {
            if (that.flag) {
                setTimeout(() => {
                    // 到规定时间后执行函数，同时flag=true
                    fn();
                    that.flag = true;
                }, delay);
            }
            // 防止一直执行
            that.flag = false;
        };
    }
    handleClear() {
        this.value = '';
    }
};
__decorate([
    Ref()
], default_1.prototype, "tree", void 0);
__decorate([
    Watch('value')
], default_1.prototype, "watchValue", null);
default_1 = __decorate([
    Component({
        name: 'ControlLeft',
        components: {
            InputSearch,
            SecondaryVerification,
        },
        i18n: {
            messages: {
                'en-us': {
                    exportDevicesByGroup: 'Export the group of devices',
                    toAdd: 'No Record, click to add',
                    createSuccess: 'create success',
                    editSuccess: 'Edit Device Success',
                    deviceGroup: 'Device Group',
                    createTitle: 'Create Device Group',
                    editTitle: 'Edit Group',
                    removeConfirm: 'Are you sure delete this group?',
                    removeSuccess: 'remove success',
                    treeEdit: 'Edit device group',
                    treeAdd: 'Create device group',
                    keyWordPlace: 'Please enter the device group name',
                    deviceName: 'Device Group name',
                    cannotBeAdd: 'Device Group level maximum: 4',
                },
                zh: {
                    cannotBeAdd: '设备组层级不能超过4级',
                    exportDevicesByGroup: '导出设备组',
                    deviceName: '设备组名称',
                    toAdd: '暂无数据点击添加',
                    createSuccess: '创建成功',
                    editSuccess: '修改成功',
                    deviceGroup: '设备组',
                    createTitle: '创建设备组',
                    editTitle: '编辑组',
                    removeConfirm: '确定要删除这个组吗？',
                    removeSuccess: '删除成功',
                    treeEdit: '编辑设备组',
                    treeAdd: '新建设备组',
                    keyWordPlace: '请输入设备组名称',
                },
            },
        },
    })
], default_1);
export default default_1;
